<template>
  <div class="lsAch">
    <h2 class="_title">My most recent achievement</h2>
    <div class="event" v-if="event">
      <div>
        <img :src="event.icon" class="ach_icon" />
        <h2>{{ event.title }}</h2>
        <p>
          {{ event.desc }}
        </p>

        <p class="ev_date">
          {{ dateFormat(event.date) }}
        </p>
      </div>
    </div>

    <div class="spinerParent" v-if="loading">
      <img src="../../assets/spinb.png" />
    </div>

    <fetchError :style="{display:fetchErr?'flex':'none', alignSelf: 'center'}" :Exception="fetchErr" />

  </div>
</template>

<script>
import Request from "../../mixins/axiosRequest.js";
import * as timeago from "timeago.js";
import fetchError from "./fetchError.vue";

export default {
  data() {
    return {
      event: undefined,
      loading: true,
      fetchErr: null
    };
  },

  components: {
    fetchError
  },

  methods: {
    async getEvent() {
      let data = await Request.axiosGet("/api/timeline/last", this.client);
      if(data.status) {
        this.event = data.data;
      } else {
        this.fetchErr = data.data;
      }
      this.loading = false;
    },

    dateFormat(raw) {
      return timeago.format(raw);
    }
  },

  mounted() {
    this.getEvent();
    this.loading = true;
  }
};
</script>

<style scoped lang="scss">

@media (prefers-color-scheme: dark) {
  .event div {
    background-color: #00000044;
  }

}

@media (prefers-color-scheme: light) {
  .event div {
    background-color: #ffffff44;
  }
}

.spinerParent {
  margin: auto 0 auto 0;
}

._title {
  font-size: 2em;
  letter-spacing: 3px;
  cursor: default;
  margin: 0 0 20px 0;
}

.event div h2 {
  font-size: 2em;
  letter-spacing: 3px;
  cursor: default;
  color: #000;
}

.event {
  padding: none;
  background-image: url("../../assets/timeline/ev_alone.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50vw;
  height: 50vw;
  max-width: 600px;
  max-height: 600px;
  margin: -30px auto -20px auto;
  background-color: transparent;
}

.event div {
  position: relative;
  height: 82.5%;
  width: 82.5%;
  border-radius: 50%;
  top: -2px;
  left: 1px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 487px;
  max-height: 487px;
}

.event p {
  margin-top: 10px;
  font-size: 1em;
  color: #000;
}

.ach_icon {
  height: 180px;
  width: 180px;
  border-radius: 50%;
  margin-top: 20px;
  margin-bottom: 15px;
  object-fit: cover;
}

.ev_date {
  font-style: italic;
}

.lsAch {
  min-height: 25vh;
  margin-top: 25px;
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 1030px) {
  .event div h2 {
    font-size: 1.6em;
    letter-spacing: 2px;
  }

  .event {
    width: 55vw;
    height: 55vw;
  }
}

@media screen and (max-width: 920px) {
  .event {
    width: 60vw;
    height: 60vw;
  }
}

@media screen and (max-width: 840px) {
  .event {
    width: 65vw;
    height: 65vw;
  }
}

@media screen and (max-width: 780px) {
  .event div h2 {
    font-size: 1.5em;
  }

  .event {
    width: 68vw;
    height: 68vw;
  }

  .event p {
    font-size: 0.95em;
  }

  .ach_icon {
    height: 160px;
    width: 160px;
  }
}

@media screen and (max-width: 670px) {
  .event {
    width: 75vw;
    height: 75vw;
  }
}

@media screen and (max-width: 600px) {
  .event div h2 {
    font-size: 1.35em;
  }

  .event {
    width: 80vw;
    height: 80vw;
  }

  .event p {
    margin-top: 7px;
    font-size: 0.9em;
  }

  .ach_icon {
    height: 150px;
    width: 150px;
  }
}

@media screen and (max-width: 545px) {
  .event {
    width: 85vw;
    height: 85vw;
  }

  .event p {
    margin-top: 6px;
  }

  .ach_icon {
    height: 140px;
    width: 140px;
    margin-top: 10px;
    margin-bottom: 5px;
  }
}

@media screen and (max-width: 475px) {
  .event div h2 {
    font-size: 1.3em;
  }

  .event {
    width: 90vw;
    height: 90vw;
    margin: -20px auto -20px auto;
  }

  .event p {
    margin-top: 4px;
    font-size: 0.8em;
  }

  .ach_icon {
    height: 135px;
    width: 135px;
    margin-top: 0px;
  }
}

@media screen and (max-width: 450px) {


  .event {
    width: 95vw;
    height: 95vw;
  }

  .event p {
    font-size: 0.9em;
  }

  .ach_icon {
    height: 115px;
    width: 115px;
  }
}

@media screen and (max-width: 400px) {
  .event div h2 {
    font-size: 1.2em;
  }

  .event {
    width: 100vw;
    height: 110vw;
  }

  .event div {
    height: 83%;
    width: 90.5%;
  }

  .event p {
    margin-top: 2px;
  }

  .ach_icon {
    height: 100px;
    width: 100px;
    margin-bottom: 3px;
  }
}

@media screen and (max-width: 340px) {
  .event div h2 {
    font-size: 1em;
  }

  .event {
    width: 100vw;
    height: 100vw;
  }

  .event div {
    height: 82.5%;
    width: 82.5%;
  }

  .event p {
    margin-top: 1px;
    font-size: 0.8em;
  }

  .ach_icon {
    height: 100px;
    width: 100px;
    margin-top: 0px;
    margin-bottom: 0px;
  }
}
</style>
